import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_CATEGORY_FAIL = "SHOP:GET_PRODUCT_CATEGORY_FAIL";

export const getProductCategoryFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_PRODUCT_CATEGORY_FAIL as typeof GET_PRODUCT_CATEGORY_FAIL,
  organization,
  id,
});

export type GetProductCategoryFailAction = ReturnType<
  typeof getProductCategoryFailAction
>;
